import React from 'react'

export const AddWorkflowEvidenceFormDescription = (): JSX.Element => (
  <span>{'Select workflow task destination'}</span>
)
